import { useState } from "react";
import Grid from "@mui/material/Grid";
import { useDispatch } from "react-redux";
import { AutocompleteAPI, Box, FormField, Modal } from "@maysoft/common-component-react";

import Helpers from "commons/helpers";
import Strings from "constants/strings";
import useDataCommon from "hooks/useDataCommon.hook";
import ProjectService from "services/medkit/project.service";

import { Status } from "constants/enum";
import { IInput } from "commons/interfaces";
import { setDataAlert, showLoading } from "store/slice/common.slice";



const projectService = new ProjectService();

const ModalAddProjectOrganization = ({
    visible,
    projectId,
    projectName,
    setVisible,
    onCallBack,
}: {
    visible: boolean;
    projectId: string;
    projectName?: string;
    onCallBack: () => void;
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
}) => {

    const dispatch = useDispatch();

    const { getDataOrganizations } = useDataCommon();

    const [organization, setOrganization] = useState<IInput>({});

    const handleCloes = () => {
        setVisible(false);
        setOrganization({});
    };

    const handleSubmit = async () => {
        if (Helpers.isNullOrEmpty(organization?.value)) {
            setOrganization({ error: Strings.PROJECT_MANAGEMENT.PLEASE_SELECT_ORGANIZATION });
        } else {
            try {
                dispatch(showLoading(true));

                await projectService.createProjectOrganization({
                    projectId: projectId,
                    organizationId: organization?.value,
                });

                const msg = Strings.formatString(Strings.PROJECT_MANAGEMENT.CREATE_PROJECT_ORGANIZATION_SUCCESS, projectName || "").toString();

                dispatch(setDataAlert({ message: msg, type: "success" }));

                onCallBack();
            } catch (error) {
                const err = Helpers.handleExceptionError(error);
                !Helpers.isNullOrEmpty(err) && dispatch(setDataAlert({ message: err, type: "error" }));
            } finally {
                dispatch(showLoading(false));
                handleCloes();
            }
        }
    };

    return (
        <Modal
            fullWidth
            hasActionButton
            maxWidth={"sm"}
            visible={visible}
            onClose={() => { handleCloes(); }}
            onAction={() => { handleSubmit(); }}
            title={Strings.formatString(Strings.PROJECT_MANAGEMENT.ADD_NEW_PROJECT_ORGANIZATION, projectName || "").toString()}
        >
            <Box padding={"24px 16px"} height={"50vh"}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <FormField
                            disabled
                            variant={"outlined"}
                            value={projectName || ""}
                            label={Strings.PROJECT_MANAGEMENT.PROJECT}
                            onChangeValue={(value) => { }}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <AutocompleteAPI
                            required
                            variant={"outlined"}
                            defaultValue={organization?.value}
                            errorMessage={organization?.error}
                            label={Strings.PROJECT_MANAGEMENT.ORGANIZATION}
                            placeholder={Strings.PROJECT_MANAGEMENT.SELECT_ORGANIZATION}
                            requestGetApi={{ status: [Status.Active] }}
                            getApi={getDataOrganizations}
                            onChange={(value) => { }}
                            onChangeItem={(value) => {
                                setOrganization({ value: value.code });
                            }}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Modal>
    );
}

export default ModalAddProjectOrganization;